export const URI_ROLE = "/api/role";
export const URI_ROLE_ADD = "/api/role";
export const URI_ROLE_DELETE = "/api/role/:id";
export const URI_ROLE_EDIT = "/api/role/:id";
export const URI_ROLE_FORM = "/api/role/:id/form";
